export default {"Card":"Card-module__Card__UdGjd"};